{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} e mais {{ moreCount }}",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} e {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} arquivo",
  "{{ count }} files_many": "{{ count }} arquivos",
  "{{ count }} files_other": "{{ count }} arquivos",
  "{{ count }} people are typing_one": "{{ count }} pessoa está digitando",
  "{{ count }} people are typing_many": "{{ count }} pessoas estão digitando",
  "{{ count }} people are typing_other": "{{ count }} pessoas estão digitando",
  "{{ count }} photos_one": "{{ count }} foto",
  "{{ count }} photos_many": "{{ count }} fotos",
  "{{ count }} photos_other": "{{ count }} fotos",
  "{{ count }} reactions_one": "{{ count }} reação",
  "{{ count }} reactions_many": "{{ count }} reações",
  "{{ count }} reactions_other": "{{ count }} reações",
  "{{ count }} videos_one": "{{ count }} vídeo",
  "{{ count }} videos_many": "{{ count }} vídeos",
  "{{ count }} videos_other": "{{ count }} vídeos",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} e {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} mais",
  "{{ memberCount }} members": "{{ memberCount }} membros",
  "{{ typing }} are typing": "{{ typing }} estão digitando",
  "{{ typing }} is typing": "{{ typing }} está digitando",
  "{{ user }} has been muted": "{{ user }} foi silenciado",
  "{{ user }} has been unmuted": "{{ user }} foi reativado",
  "{{ user }} is typing...": "{{ user }} está digitando...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} e {{ user }} estão digitando...",
  "{{ users }} and more are typing...": "{{ users }} e mais estão digitando...",
  "{{ watcherCount }} online": "{{ watcherCount }} online",
  "{{count}} new messages_one": "{{count}} nova mensagem",
  "{{count}} new messages_many": "{{count}} novas mensagens",
  "{{count}} new messages_other": "{{count}} novas mensagens",
  "{{count}} unread_one": "{{count}} não lido",
  "{{count}} unread_many": "{{count}} não lidos",
  "{{count}} unread_other": "{{count}} não lidos",
  "{{count}} votes_one": "{{count}} voto",
  "{{count}} votes_many": "{{count}} votos",
  "{{count}} votes_other": "{{count}} votos",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} opção a mais",
  "+{{count}} more options_many": "+{{count}} opções a mais",
  "+{{count}} more options_other": "+{{count}} opções a mais",
  "🏙 Attachment...": "🏙 Anexo...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} criou: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} votou: {{pollOptionText}}",
  "📍Shared location": "📍Localização compartilhada",
  "Add a comment": "Adicionar um comentário",
  "Add a comment to your poll answer": "Adicione um comentário à sua resposta da enquete",
  "Add an option": "Adicionar uma opção",
  "Add reaction": "Adicionar reação",
  "All results loaded": "Todos os resultados carregados",
  "Allow access to camera": "Permitir acesso à câmera",
  "Allow access to microphone": "Permitir acesso ao microfone",
  "Allow comments": "Permitir comentários",
  "Allow option suggestion": "Permitir sugestão de opção",
  "Allow others to add comments": "Permitir que outros adicionem comentários",
  "Also send as a direct message": "Também enviar como mensagem direta",
  "Also send in channel": "Também enviar no canal",
  "Also sent in channel": "Também enviado no canal",
  "An error has occurred during recording": "Ocorreu um erro durante a gravação",
  "An error has occurred during the recording processing": "Ocorreu um erro durante o processamento da gravação",
  "Anonymous": "Anônimo",
  "Anonymous poll": "Enquete anônima",
  "Archive": "Arquivar",
  "Are you sure you want to delete this message?": "Tem certeza de que deseja excluir esta mensagem?",
  "aria/Attachment": "Anexo",
  "aria/Attachment Actions": "Ações do anexo",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Posição do áudio {{ elapsed }} de {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Posição do áudio {{ progress }} por cento",
  "aria/Block User": "Bloquear usuário",
  "aria/Bookmark Message": "Marcar mensagem",
  "aria/Cancel recording": "Cancelar gravação",
  "aria/Cancel Reply": "Cancelar resposta",
  "aria/Cancel upload": "Cancelar upload",
  "aria/Channel Actions": "Ações do canal",
  "aria/Channel list": "Lista de canais",
  "aria/Channel search results": "Resultados de pesquisa de canais",
  "aria/Chat view tabs": "Abas da visualização do chat",
  "aria/Clear search": "Limpar pesquisa",
  "aria/Close callout dialog": "Fechar diálogo de destaque",
  "aria/Close thread": "Fechar tópico",
  "aria/Collapse sidebar": "Recolher barra lateral",
  "aria/Command Suggestions": "Sugestões de comandos",
  "aria/Complete recording": "Concluir gravação",
  "aria/Copy Message Text": "Copiar texto da mensagem",
  "aria/Decrease value": "Diminuir valor",
  "aria/Delete Message": "Excluir mensagem",
  "aria/Dismiss notification": "Dispensar notificação",
  "aria/Download attachment": "Baixar anexo",
  "aria/Edit Message": "Editar Mensagem",
  "aria/Emoji picker": "Seletor de emojis",
  "aria/Emoji Suggestions": "Sugestões de emojis",
  "aria/Exit search": "Sair da pesquisa",
  "aria/Expand sidebar": "Expandir barra lateral",
  "aria/File input": "Entrada de arquivo",
  "aria/File upload": "Carregar arquivo",
  "aria/Flag Message": "Reportar mensagem",
  "aria/Image failed to load": "Falha ao carregar a imagem",
  "aria/Image input": "Entrada de imagem",
  "aria/Increase value": "Aumentar valor",
  "aria/Jump to latest message": "Ir para a mensagem mais recente",
  "aria/Jump to quoted message": "Ir para a mensagem citada",
  "aria/Load More Channels": "Carregar mais canais",
  "aria/Mark Message Unread": "Marcar como não lida",
  "aria/Mark messages as read": "Marcar mensagens como lidas",
  "aria/Menu": "Menu",
  "aria/Message Actions": "Ações da mensagem",
  "aria/Message from {{ user }},": "Mensagem de {{ user }},",
  "aria/Message Options": "Opções de mensagem",
  "aria/Message,": "Mensagem,",
  "aria/Mute User": "Silenciar usuário",
  "aria/Notifications": "Notificações",
  "aria/Open Attachment Selector": "Abrir seletor de anexos",
  "aria/Open Channel Actions Menu": "Abrir menu de ações do canal",
  "aria/Open Menu": "Abrir menu",
  "aria/Open Message Actions Menu": "Abrir menu de ações de mensagem",
  "aria/Open Reaction Selector": "Abrir seletor de reações",
  "aria/Open Thread": "Abrir tópico",
  "aria/Pause": "Pausar",
  "aria/Pause recording": "Pausar gravação",
  "aria/Percent complete": "{{percent}} por cento concluído",
  "aria/Pin Message": "Fixar mensagem",
  "aria/Play": "Reproduzir",
  "aria/Quote Message": "Citar mensagem",
  "aria/Reaction list": "Lista de reações",
  "aria/Remind Me Message": "Lembrar-me",
  "aria/Remind Me Options": "Opções de lembrete",
  "aria/Remove attachment": "Remover anexo",
  "aria/Remove location attachment": "Remover anexo de localização",
  "aria/Remove option": "Remover opção",
  "aria/Remove Reminder": "Remover lembrete",
  "aria/Remove Save For Later": "Remover Salvar para depois",
  "aria/Resend Message": "Reenviar mensagem",
  "aria/Resume recording": "Retomar gravação",
  "aria/Retry upload": "Tentar upload novamente",
  "aria/Review bounced message": "Revisar mensagem devolvida",
  "aria/Search results": "Resultados da pesquisa",
  "aria/Search results header filter button for: {{ source }}": "Botão de filtro do cabeçalho dos resultados da pesquisa para: {{ source }}",
  "aria/Seek audio position": "Buscar posição do áudio",
  "aria/Select Channel: {{ channelName }}": "Selecionar canal: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Selecionar reação: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Selecionar canal do usuário: {{ name }}",
  "aria/Send": "Enviar",
  "aria/Show preview": "Mostrar prévia",
  "aria/Start recording audio": "Iniciar gravação de áudio",
  "aria/Stop AI Generation": "Parar geração de IA",
  "aria/Suggestions": "Sugestões",
  "aria/Thread list": "Lista de tópicos",
  "aria/Unblock User": "Desbloquear usuário",
  "aria/Unmute User": "Ativar som",
  "aria/Unpin Message": "Desfixar mensagem",
  "aria/User Suggestions": "Sugestões de usuários",
  "Ask a question": "Faça uma pergunta",
  "Attach": "Anexar",
  "Attach files": "Anexar arquivos",
  "Attachment": "Anexo",
  "Attachment upload blocked due to {{reason}}": "Upload de anexo bloqueado devido a {{reason}}",
  "Attachment upload failed due to {{reason}}": "Upload de anexo falhou devido a {{reason}}",
  "Back": "Voltar",
  "ban-command-args": "[@nomedeusuário] [texto]",
  "ban-command-description": "Banir um usuário",
  "Block User": "Bloquear usuário",
  "Cancel": "Cancelar",
  "Cannot seek in the recording": "Não é possível buscar na gravação",
  "Channel archived": "Canal arquivado",
  "Channel Missing": "Canal ausente",
  "Channel muted": "Canal silenciado",
  "Channel pinned": "Canal fixado",
  "Channel unarchived": "Canal desarquivado",
  "Channel unmuted": "Silêncio do canal desativado",
  "Channel unpinned": "Canal desafixado",
  "Channels": "Canais",
  "Chats": "Conversas",
  "Choose between 2 to 10 options": "Escolha entre 2 a 10 opções",
  "Close": "Fechar",
  "Close dialog": "Fechar diálogo",
  "Close emoji picker": "Fechar seletor de emoji",
  "Close prompt: {{ title }}": "Fechar prompt: {{ title }}",
  "Command not available while editing": "Comando não disponível durante a edição",
  "Command not available while replying": "Comando não disponível durante a resposta",
  "Commands": "Comandos",
  "Commands matching": "Comandos correspondentes",
  "Connection failure, reconnecting now...": "Falha de conexão, reconectando agora...",
  "Copy Message": "Copiar mensagem",
  "Create": "Criar",
  "Create a question, add options, and configure poll settings": "Crie uma pergunta, adicione opções e configure as definições da enquete",
  "Create poll": "Criar enquete",
  "Current location": "Localização atual",
  "Delete": "Excluir",
  "Delete for me": "Excluir para mim",
  "Delete message": "Excluir mensagem",
  "Delivered": "Entregue",
  "Direct message": "Mensagem direta",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Deseja encerrar esta enquete agora? Ninguém poderá mais votar nesta enquete.",
  "Download All": "Baixar tudo",
  "Download Attachment": "Baixar anexo",
  "Download attachment {{ name }}": "Baixar anexo {{ name }}",
  "Drag your files here": "Arraste seus arquivos aqui",
  "Drag your files here to add to your post": "Arraste seus arquivos aqui para adicionar ao seu post",
  "Due {{ timeLeft }}": "Vence em {{ timeLeft }}",
  "Due since {{ dueSince }}": "Vencido desde {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Editar Mensagem",
  "Edit message request failed": "O pedido de edição da mensagem falhou",
  "Edited": "Editada",
  "Emoji matching": "Emoji correspondente",
  "Empty message...": "Mensagem vazia...",
  "End": "Fim",
  "End poll": "Encerrar enquete",
  "End this poll?": "Encerrar esta enquete?",
  "End vote": "Encerrar votação",
  "Enforce unique vote is enabled": "Voto único está habilitado",
  "Error": "Erro",
  "Error adding flag": "Erro ao reportar",
  "Error connecting to chat, refresh the page to try again.": "Erro ao conectar ao bate-papo, atualize a página para tentar novamente.",
  "Error deleting message": "Erro ao deletar mensagem",
  "Error fetching reactions": "Erro ao carregar reações",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Erro ao marcar a mensagem como não lida. Não é possível marcar mensagens não lidas mais antigas do que as 100 mensagens mais recentes do canal.",
  "Error muting a user ...": "Erro ao silenciar um usuário...",
  "Error pinning message": "Erro ao fixar mensagem",
  "Error removing message pin": "Erro ao remover o PIN da mensagem",
  "Error reproducing the recording": "Erro ao reproduzir a gravação",
  "Error starting recording": "Erro ao iniciar a gravação",
  "Error unmuting a user ...": "Erro ao ativar o som de um usuário...",
  "Error uploading attachment": "Erro ao carregar o anexo",
  "Error uploading file": "Erro ao enviar arquivo",
  "Error uploading image": "Erro ao carregar a imagem",
  "Error: {{ errorMessage }}": "Erro: {{ errorMessage }}",
  "Exit command {{ command }}": "Sair do comando {{ command }}",
  "Failed to block user": "Falha ao bloquear o usuário",
  "Failed to create the poll": "Falha ao criar a pesquisa",
  "Failed to create the poll due to {{reason}}": "Falha ao criar a enquete devido a {{reason}}",
  "Failed to delete the message": "Falha ao excluir a mensagem",
  "Failed to end the poll": "Falha ao encerrar a enquete",
  "Failed to end the poll due to {{reason}}": "Falha ao encerrar a enquete devido a {{reason}}",
  "Failed to jump to the first unread message": "Falha ao pular para a primeira mensagem não lida",
  "Failed to leave channel": "Falha ao sair do canal",
  "Failed to load channels": "Falha ao carregar os canais",
  "Failed to load more channels": "Falha ao carregar mais canais",
  "Failed to mark channel as read": "Falha ao marcar o canal como lido",
  "Failed to play the recording": "Falha ao reproduzir a gravação",
  "Failed to retrieve location": "Falha ao obter localização",
  "Failed to share location": "Falha ao compartilhar localização",
  "Failed to update channel archive status": "Falha ao atualizar o status de arquivamento do canal",
  "Failed to update channel mute status": "Falha ao atualizar o status de mudo do canal",
  "Failed to update channel pinned status": "Falha ao atualizar o status de fixação do canal",
  "File": "Arquivo",
  "File is required for upload attachment": "Arquivo é necessário para enviar o anexo",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "O arquivo é muito grande: {{ size }}, o tamanho máximo de upload é {{ limit }}",
  "File too large": "Arquivo muito grande",
  "fileCount_one": "1 arquivo",
  "fileCount_many": "{{ count }} arquivos",
  "fileCount_other": "{{ count }} arquivos",
  "Flag": "Reportar",
  "Generating...": "Gerando...",
  "giphy-command-args": "[texto]",
  "giphy-command-description": "Postar um gif aleatório no canal",
  "Hide who voted": "Ocultar quem votou",
  "Image": "Imagem",
  "imageCount_one": "Imagem",
  "imageCount_many": "{{ count }} imagens",
  "imageCount_other": "{{ count }} imagens",
  "Instant commands": "Comandos instantâneos",
  "language/af": "Africâner",
  "language/am": "Amárico",
  "language/ar": "Árabe",
  "language/az": "Azerbaijano",
  "language/bg": "Búlgaro",
  "language/bn": "Bengali",
  "language/bs": "Bósnio",
  "language/cs": "Tcheco",
  "language/da": "Dinamarquês",
  "language/de": "Alemão",
  "language/el": "Grego",
  "language/en": "Inglês",
  "language/es": "Espanhol",
  "language/es-MX": "Espanhol (México)",
  "language/et": "Estoniano",
  "language/fa": "Persa",
  "language/fa-AF": "Dari",
  "language/fi": "Finlandês",
  "language/fr": "Francês",
  "language/fr-CA": "Francês (Canadá)",
  "language/ha": "Hauçá",
  "language/he": "Hebraico",
  "language/hi": "Hindi",
  "language/hr": "Croata",
  "language/ht": "Crioulo haitiano",
  "language/hu": "Húngaro",
  "language/id": "Indonésio",
  "language/it": "Italiano",
  "language/ja": "Japonês",
  "language/ka": "Georgiano",
  "language/ko": "Coreano",
  "language/lt": "Lituano",
  "language/lv": "Letão",
  "language/ms": "Malaio",
  "language/nl": "Holandês",
  "language/no": "Norueguês",
  "language/pl": "Polonês",
  "language/ps": "Pashto",
  "language/pt": "Português",
  "language/ro": "Romeno",
  "language/ru": "Russo",
  "language/sk": "Eslovaco",
  "language/sl": "Esloveno",
  "language/so": "Somali",
  "language/sq": "Albanês",
  "language/sr": "Sérvio",
  "language/sv": "Sueco",
  "language/sw": "Suaíli",
  "language/ta": "Tâmil",
  "language/th": "Tailandês",
  "language/tl": "Tagalo",
  "language/tr": "Turco",
  "language/uk": "Ucraniano",
  "language/ur": "Urdu",
  "language/vi": "Vietnamita",
  "language/zh": "Chinês (simplificado)",
  "language/zh-TW": "Chinês (tradicional)",
  "Leave Channel": "Sair do canal",
  "Left channel": "Canal abandonado",
  "Let others add options": "Permitir que outros adicionem opções",
  "Limit votes per person": "Limitar votos por pessoa",
  "Link": "Link",
  "linkCount_one": "Link",
  "linkCount_many": "{{ count }} links",
  "linkCount_other": "{{ count }} links",
  "live": "ao vivo",
  "Live for {{duration}}": "Ao vivo por {{duration}}",
  "Live location": "Localização ao vivo",
  "Live until {{ timestamp }}": "Ao vivo até {{ timestamp }}",
  "Load more": "Carregar mais",
  "Local upload attachment missing local id": "Anexo de envio local sem id local",
  "Location": "Localização",
  "Location sharing ended": "Compartilhamento de localização encerrado",
  "Location: {{ coordinates }}": "Localização: {{ coordinates }}",
  "Mark as unread": "Marcar como não lida",
  "Maximum number of votes (from 2 to 10)": "Número máximo de votos (de 2 a 10)",
  "Maximum votes per person": "Máximo de votos por pessoa",
  "Menu": "Menu",
  "Message deleted": "Mensagem apagada",
  "Message failed to send": "Falha ao enviar a mensagem",
  "Message has been successfully flagged": "A mensagem foi reportada com sucesso",
  "Message marked as unread": "Mensagem marcada como não lida",
  "Message pinned": "Mensagem fixada",
  "Message unpinned": "Mensagem desafixada",
  "Message was blocked by moderation policies": "A mensagem foi bloqueada pelas políticas de moderação",
  "Messages have been marked unread.": "Mensagens foram marcadas como não lidas.",
  "Missing permissions to upload the attachment": "Faltando permissões para enviar o anexo",
  "Multiple votes": "Votos múltiplos",
  "Mute": "Silenciar",
  "mute-command-args": "[@nomedeusuário]",
  "mute-command-description": "Silenciar um usuário",
  "network error": "erro de rede",
  "New": "Novo",
  "New message from {{user}}": "Nova mensagem de {{user}}",
  "New Messages!": "Novas Mensagens!",
  "Next image": "Próxima imagem",
  "No chats here yet…": "Ainda não há conversas aqui...",
  "No conversations yet": "Ainda não há conversas",
  "No items exist": "Não existem itens",
  "No results found": "Nenhum resultado encontrado",
  "Nobody will be able to vote in this poll anymore.": "Ninguém mais poderá votar nesta pesquisa.",
  "Nothing yet...": "Nada ainda...",
  "Offline": "Offline",
  "Ok": "OK",
  "Online": "Online",
  "Only numbers are allowed": "Apenas números são permitidos",
  "Only visible to you": "Visível apenas para você",
  "Open emoji picker": "Abrir seletor de emoji",
  "Open gallery at image {{ index }}": "Abrir galeria na imagem {{ index }}",
  "Open image in gallery": "Abrir imagem na galeria",
  "Open location in a map": "Abrir localização em um mapa",
  "Option already exists": "Opção já existe",
  "Option is empty": "A opção está vazia",
  "Options": "Opções",
  "Original": "Original",
  "People matching": "Pessoas correspondentes",
  "Photo": "Foto",
  "Pin": "Fixar",
  "Pinned by {{ name }}": "Fixado por {{ name }}",
  "Pinned by You": "Fixado por você",
  "placeholder/PollComment": "O seu comentário",
  "placeholder/PollOptionSuggestion": "Introduza uma nova opção",
  "Play video": "Reproduzir vídeo",
  "Playback speed {{ rate }}x": "Velocidade de reprodução {{ rate }}x",
  "Poll": "Enquete",
  "Poll comments": "Comentários da pesquisa",
  "Poll ended": "Enquete encerrada",
  "Poll options": "Opções da pesquisa",
  "Poll results": "Resultados da pesquisa",
  "Previous image": "Imagem anterior",
  "Question": "Pergunta",
  "Question {{ optionOrderNumber}}": "Pergunta {{ optionOrderNumber}}",
  "Question is required": "A pergunta é obrigatória",
  "Quote Reply": "Responder com citação",
  "Reached the vote limit. Remove an existing vote first.": "Limite de votos atingido. Remova um voto existente primeiro.",
  "Recording format is not supported and cannot be reproduced": "Formato de gravação não é suportado e não pode ser reproduzido",
  "Remind me": "Lembrar-me",
  "Remind Me": "Lembrar-me",
  "Reminder set": "Lembrete definido",
  "Remove reminder": "Remover lembrete",
  "Remove save for later": "Remover Salvar para depois",
  "Replied to a thread": "Respondeu em um tópico",
  "Reply": "Responder",
  "Reply to {{ authorName }}": "Responder a {{ authorName }}",
  "Reply to a message to start a thread": "Responda a uma mensagem para iniciar um thread",
  "Reply to Message": "Responder à mensagem",
  "replyCount_one": "1 resposta",
  "replyCount_many": "{{ count }} respostas",
  "replyCount_other": "{{ count }} respostas",
  "Resend": "Reenviar",
  "Retry upload": "Tentar enviar novamente",
  "Review all options available in this poll": "Revise todas as opções disponíveis nesta enquete",
  "Review comments submitted with poll answers": "Revise comentários enviados com respostas da enquete",
  "Review poll results and open an option to see detailed votes": "Revise os resultados da enquete e abra uma opção para ver votos detalhados",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Revise esta mensagem e escolha se deseja excluí-la, editá-la ou enviá-la mesmo assim",
  "Review who voted for this option": "Revise quem votou nesta opção",
  "Save for later": "Salvar para depois",
  "Saved for later": "Salvo para depois",
  "Search": "Buscar",
  "Search GIFs": "Pesquisar GIFs",
  "search-results-header-filter-source-button-label--channels": "canais",
  "search-results-header-filter-source-button-label--messages": "mensagens",
  "search-results-header-filter-source-button-label--users": "usuários",
  "Searching for {{ searchSourceType }}...": "Buscando {{ searchSourceType }}...",
  "Searching...": "Buscando...",
  "searchResultsCount_one": "1 resultado",
  "searchResultsCount_many": "{{ count }} resultados",
  "searchResultsCount_other": "{{ count }} resultados",
  "Select a thread to continue the conversation": "Selecione uma thread para continuar a conversa",
  "Select more than one option": "Selecionar mais de uma opção",
  "Select one": "Selecionar um",
  "Select one or more": "Selecionar um ou mais",
  "Select up to {{count}}_one": "Selecionar até {{count}}",
  "Select up to {{count}}_many": "Selecionar até {{count}}",
  "Select up to {{count}}_other": "Selecionar até {{count}}",
  "Select your current location and optionally enable live location sharing": "Selecione sua localização atual e, opcionalmente, ative o compartilhamento de localização ao vivo",
  "Send": "Enviar",
  "Send a message": "Envie uma mensagem",
  "Send a message to start the conversation": "Envie uma mensagem para iniciar a conversa",
  "Send Anyway": "Enviar de qualquer forma",
  "Send message request failed": "O pedido de envio da mensagem falhou",
  "Send poll": "Enviar enquete",
  "Sending...": "Enviando...",
  "Sent": "Enviado",
  "Share": "Compartilhar",
  "Share live location for": "Compartilhar localização ao vivo por",
  "Share Location": "Compartilhar localização",
  "Shared live location": "Localização ao vivo compartilhada",
  "Shared location": "Localização compartilhada",
  "Shuffle": "Embaralhar",
  "size limit": "limite de tamanho",
  "Slow Mode ON": "Modo lento LIGADO",
  "Slow mode, wait {{ seconds }}s...": "Modo lento, aguarde {{ seconds }} s...",
  "Some of the files will not be accepted": "Alguns arquivos não serão aceitos",
  "Start typing to search": "Comece a digitar para pesquisar",
  "Stop sharing": "Parar de compartilhar",
  "Submit": "Enviar",
  "Suggest a new option to add to this poll": "Sugira uma nova opção para adicionar a esta enquete",
  "Suggest an option": "Sugerir uma opção",
  "Tap to remove": "Toque para remover",
  "Tap to remove: {{ reactionName }}": "Toque para remover: {{ reactionName }}",
  "Thinking...": "Pensando...",
  "this content could not be displayed": "este conteúdo não pôde ser exibido",
  "This field cannot be empty or contain only spaces": "Este campo não pode estar vazio ou conter apenas espaços",
  "This message did not meet our content guidelines": "Esta mensagem não corresponde às nossas diretrizes de conteúdo",
  "Thread": "Fio",
  "Thread has not been found": "Fio não encontrado",
  "Thread reply": "Resposta no fio",
  "Thread Reply": "Resposta no fio",
  "ThreadListUnseenThreadsBanner/loading": "Carregando...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} tópico não lido",
  "ThreadListUnseenThreadsBanner/unreadThreads_many": "{{ count }} tópicos não lidos",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} tópicos não lidos",
  "Threads": "Tópicos",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Ontem]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Hoje]\", \"nextDay\": \"[Amanhã]\", \"lastDay\": \"[Ontem]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Último] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Hoje",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Ontem",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Para começar a gravar, permita o acesso à câmera no seu navegador",
  "To start recording, allow the microphone access in your browser": "Para começar a gravar, permita o acesso ao microfone no seu navegador",
  "totalVoteCount_one": "1 voto no total",
  "totalVoteCount_many": "{{ count }} votos no total",
  "totalVoteCount_other": "{{ count }} votos no total",
  "Translated": "Traduzido",
  "Translated from {{ language }}": "Traduzido de {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Digite um número de 2 a 10",
  "Unarchive": "Desarquivar",
  "unban-command-args": "[@nomedeusuário]",
  "unban-command-description": "Desbanir um usuário",
  "Unblock User": "Desbloquear usuário",
  "unknown error": "erro desconhecido",
  "Unmute": "Ativar som",
  "unmute-command-args": "[@nomedeusuário]",
  "unmute-command-description": "Retirar o silenciamento de um usuário",
  "Unpin": "Desfixar",
  "Unread messages": "Mensagens não lidas",
  "Unsupported attachment": "Anexo não suportado",
  "unsupported file type": "tipo de arquivo não suportado",
  "Update": "Atualizar",
  "Update the comment attached to your poll answer": "Atualize o comentário anexado à sua resposta da enquete",
  "Update your comment": "Atualizar seu comentário",
  "Upload blocked": "Envio bloqueado",
  "Upload error": "Erro no envio",
  "Upload failed": "Falha no envio",
  "Upload type: \"{{ type }}\" is not allowed": "Tipo de upload: \"{{ type }}\" não é permitido",
  "User blocked": "Usuário bloqueado",
  "User unblocked": "Usuário desbloqueado",
  "User uploaded content": "Conteúdo enviado pelo usuário",
  "Video": "Vídeo",
  "videoCount_one": "Vídeo",
  "videoCount_many": "{{ count }} vídeos",
  "videoCount_other": "{{ count }} vídeos",
  "View": "Ver",
  "View {{count}} comments_one": "Ver {{count}} comentário",
  "View {{count}} comments_many": "Ver {{count}} comentários",
  "View {{count}} comments_other": "Ver {{count}} comentários",
  "View all": "Ver tudo",
  "View original": "Ver original",
  "View results": "Ver resultados",
  "View translation": "Ver tradução",
  "Voice message": "Mensagem de voz",
  "Voice message {{ duration }}": "Mensagem de voz {{ duration }}",
  "Voice message deleted": "Mensagem de voz excluída",
  "voiceMessageCount_one": "Mensagem de voz",
  "voiceMessageCount_many": "{{ count }} mensagens de voz",
  "voiceMessageCount_other": "{{ count }} mensagens de voz",
  "Vote ended": "Votação encerrada",
  "Votes": "Votos",
  "Wait until all attachments have uploaded": "Espere até que todos os anexos tenham sido carregados",
  "Waiting for network…": "Aguardando rede…",
  "You": "Você",
  "You've reached the maximum number of files": "Você atingiu o número máximo de arquivos"
}
